import { useEffect } from 'react';
import { issueViewOpenInteraction } from '../../../services/utils/performance-analytics/index.tsx';

export const PreIssueViewMountFeedbackMark = ({ issueKey }: { issueKey: string }) => {
	useEffect(() => {
		issueViewOpenInteraction.mark('feedbackPreMountEnd');
	}, [issueKey]);
	return null;
};
